import { createSelector } from "reselect";
import { State } from "../state";

export const getBriefSpreadState = (state: State) => state.briefSpread;

export const getBriefSpread = createSelector(
  getBriefSpreadState,
  briefSpreadState => {
    return briefSpreadState.briefSpread || [];
  }
);

export const getBriefSpreadSort = (state: State) => {
  return state.searchOptions.spreadSort || state.briefSpread.spreadSort;
};

export const getBriefSpreadPage = (state: State) => {
  return state.searchOptions.page || state.briefSpread.currentPage || 0;
};

export const getBriefSpreadQuery = (state: State) => {
  return state.searchOptions.query || state.briefSpread.searchTerm;
};

export const getBriefSpreadFilter = (state: State) => {
  return state.searchOptions.spreadFilter || state.briefSpread.spreadFilter;
};

export const getBriefSpreadStatusGroup = (state: State) => {
  return state.briefSpread.statusGroup;
};

export const getActiveTab = (state: State) => {
  return state.searchOptions.activeTab || state.briefSpread.activeTab;
};

export const getPollingEnabled = (state: State) => {
  return state.pollingEnabled;
};



// WEBPACK FOOTER //
// ./src/documentList/selector.ts